export type StrongAuthenticationKind = 'sso_and_sms_otp' | 'otp';

export type StrongAuthenticationChannel = 'sms' | 'email';

export type StrongAuthenticationError = {
  error_code: 'strong_authentication_required';
  error_details: { kind: StrongAuthenticationKind };
};

export const isStrongAuthenticationError = (data?: {
  error_code?: string;
}): data is StrongAuthenticationError => data?.error_code === 'strong_authentication_required';

export type InitiateStrongAuthWithSsoError = 'should_not_use_sso';
export type SubmitSsoProofError = 'no_verified_phone' | 'invalid_strong_authentication_session';
export type AuthenticateWithSsoAndCodeError =
  | 'invalid_code'
  | 'no_verified_phone'
  | 'invalid_strong_authentication_session';

export type InitiateStrongAuthWithSsoResponse =
  | { success: true; identity_provider_url: string }
  | { success: false; reason: InitiateStrongAuthWithSsoError };

export type SubmitSsoProofParams = {
  sso_proof_token: string;
};

export type SubmitSsoProofResponse =
  | { success: true; challenge_token: string }
  | { success: false; reason: SubmitSsoProofError };

export type AuthenticateWithSsoAndCodeParams = {
  sso_proof_token: string;
  challenge_token: string;
  code: string;
};

export type AuthenticateWithSsoAndCodeResponse =
  | { success: true; expires_at: string }
  | { success: false; reason: AuthenticateWithSsoAndCodeError };

export type InitiateOtpAuthenticationError = 'no_otp_destination';
export type AuthenticateWithCodeError = 'invalid_code' | 'invalid_strong_authentication_session';

export type InitiateOtpAuthenticationResponse =
  | {
      success: true;
      challenge_token: string;
      channel: StrongAuthenticationChannel;
      destination: string;
    }
  | { success: false; reason: InitiateOtpAuthenticationError };

export type AuthenticateWithCodeParams = {
  challenge_token: string;
  code: string;
};

export type AuthenticateWithCodeResponse =
  | { success: true; expires_at: string }
  | { success: false; reason: AuthenticateWithCodeError };
